const rawBackendUrl = process.env.REACT_APP_API_ENDPOINT ?? ""
// ทั้งโปรเจกต์ต่อ path แบบ `${backendUrl}images/...` → บังคับให้ลงท้ายด้วย "/" เสมอ
// (env ที่ไม่มี "/" ท้าย เช่น https://api.bangbow.com จะได้ host ผิดเป็น https://api.bangbow.comimages/...)
export const backendUrl = rawBackendUrl && !rawBackendUrl.endsWith("/") ? `${rawBackendUrl}/` : rawBackendUrl

//export const backendUrl = "https://api.bangbow.com/";
// export const backendUrl = "https://api-dev.bangbow.com/";
// export const backendUrl = 'http://localhost:4000/'

/**
 * Feature flags
 * - ปุ่ม "ตั้งค่าสต็อก" (ในหน้า SKU card)
 * - ตอนนี้ซ่อนไว้ก่อน โดยสามารถเปิดได้ด้วยการตั้งค่าเป็น true
 */
export const SHOW_STOCK_SETTINGS_BUTTON = false

/** ฟีเจอร์ "แจ้งเตือนสต็อก" (safe stock) — ปิดไว้ก่อน ยังไม่เปิดใช้งานในระบบสต็อก */
export const SHOW_STOCK_ALERT = false


export const allowFileExtensionsImage = ".jpg, .jpeg, .png";

export const goToSignInPage = (url: string | undefined, delay = 1000) => {
  setTimeout(() => {
    window.open(url, "_self");
  }, delay);
};

export const orderManualConfirm = ["manual_transfer"];


export const loginEncryptionKey = process.env.REACT_APP_LOGIN_ENCRYPTION_KEY